module.exports = __webpack_public_path__ + "img/covoiturage-libre.png";